import  { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import instance from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import LanguajeCurrency from "./LanguajeCurrency";
import { useTranslation } from "@hooks/useTranslation";
import { useAuth } from "@context/AuthContext";

const Component = ({ wishlist }) => {

  const { getToken,getVerified } = useContext(TokenContext);
  const { translate } = useTranslation();
  const { openAuth } = useAuth();

  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const totalQuantity = JSON.parse(localStorage.getItem('cart'))?.length || 0;

  const handleSearch = () => {
    if (searchValue) {

      instance.get(`/products/search?search=${searchValue}&per_page=16`)
        .then(response => {
          if (response.data.products.length === 0) {
            navigate('/sin-resultados', {
              state: { searchTerm: searchValue }
            });
            return;
          }
         
          const valor = searchValue
          setSearchValue("");
          navigate('/resultados/'+valor)

        })
        .catch(() => {
          navigate('/sin-resultados', {
            state: { searchTerm: searchValue }
          });
        });
    } else {
      navigate('/sin-resultados');
    }
  };

  useEffect(() => {

  },[getVerified,getToken]);

  return (
    <header className="Column">

      <div className="HeaderFirst">
        <div
          className="ImageIcon ArtOnU"
          style={{ cursor:"pointer" }}
          onClick={() => navigate("/home")}
        ></div>
        <div className="HeaderMenus">
          <label className="FormData">
            <div className="FormInputMedium">
              <input
                placeholder={translate('home.search')}
                type="search"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
              <i className="InputIcon icon-Search" onClick={handleSearch}></i>
            </div>
          </label>
          <div className="Bubbles Row">
            <div className="icon-User" onClick={() => (getToken() && getVerified()) ? navigate("/mi-perfil") : openAuth('IniciarSesionWith')} style={{ "cursor":"pointer" }}>
              {" "}
              {(getToken() && getVerified()) ? translate('my_account_') : translate('login.title')}
            </div>
            
            <div className="icon-Hearty" onClick={() => (getToken() && getVerified()) ? navigate("/wishlist") : openAuth('IniciarSesionWith')} style={{ "cursor":"pointer" }}>
              {wishlist ? <div className="Bubble">{wishlist}</div> : ""}
            </div>
            <div
            style={{ "cursor":"pointer" }}
              className="icon-Trolley"
              onClick={() => navigate("/carrito")}
            >
              {(totalQuantity>0) ? <div className="Bubble">{totalQuantity}</div> : ""}
            </div>
          </div>
        </div>
      </div>

      <LanguajeCurrency />
    </header>
  );

};

export default Component;
